/**
 * Document version history via Loro's logical time-travel. Non-destructive and
 * available everywhere (local dev + tests). For whole-agent disaster recovery
 * see `Recovery` (Durable Object point-in-time recovery).
 */
export class History {
    doc;
    /** @param options - Shared document used for version history operations. */
    constructor(options) {
        this.doc = options.doc;
    }
    /**
     * Lists historical versions, oldest first and openable via `preview` or `revertTo`.
     *
     * Timestamps require `doc.setRecordTimestamp(true)` before commits; CollabRoom
     * enables recording during initialization.
     *
     * @returns Historical document versions in chronological order.
     */
    versions() {
        const changes = [...this.doc.getAllChanges()].flatMap(([peer, peerChanges]) => peerChanges.map((change) => ({ peer, change })));
        changes.sort((a, b) => a.change.timestamp - b.change.timestamp ||
            a.change.lamport - b.change.lamport ||
            String(a.peer).localeCompare(String(b.peer)) ||
            a.change.counter - b.change.counter);
        const counters = new Map();
        return changes.map(({ peer, change }) => {
            counters.set(peer, change.counter + change.length - 1);
            return {
                frontiers: [...counters].map(([frontierPeer, counter]) => ({
                    peer: frontierPeer,
                    counter,
                })),
                timestamp: change.timestamp,
                peer,
                message: change.message,
            };
        });
    }
    /**
     * Creates a read-only fork at a past version.
     *
     * @param frontiers - Loro frontiers selecting a historical version.
     * @returns A read-only document fork at that version.
     */
    preview(frontiers) {
        return this.doc.forkAt(frontiers);
    }
    /**
     * Rolls the live document back with non-destructive inverse operations.
     *
     * @param frontiers - Loro frontiers selecting the target version.
     */
    revertTo(frontiers) {
        this.doc.revertTo(frontiers);
        this.doc.commit();
    }
}
//# sourceMappingURL=history.js.map